import { useState, useEffect } from 'react'

export const useCalendlyRoot = () => {
  const [rootElement, setRootElement] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const element = document.getElementById('root')
    if (element) {
      setRootElement(element)
    }
  }, [])

  return rootElement
}
